import './telematicsVideoList.css';
import TelematicsVideo from "../telematicsVideo/telematicsVideo";
import {videos} from "../../../data/videosData";

const TelematicsVideoList = ({handleShowVideoPlayer}) => {
    const tags = videos;
    return(
        <ul className={'telematics-videos-list grid col-3'}>
            {
                tags.map((video, index) =>
                    <TelematicsVideo
                        handleShowVideoPlayer={handleShowVideoPlayer}
                        video={video} key={index} index={index}/>
                )
            }
        </ul>
    )
}

export default TelematicsVideoList;
